import { useIsMobile } from '@vayufp/coast-components';
import { useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { resetAddressLookup } from '../../../address-verification/reducers/addressLookup';
import { PreviewCardForm } from '../../components/preview-card-form';

const selector = ({ addressLookup: { error: addressError }, nextStep: { error: appError } }: RootState) => ({
  error: addressError ?? appError,
});

const PreviewCardPage: FC = () => {
  const dispatch = useDispatch();
  const { error } = useSelector(selector);
  const isMobile = useIsMobile();

  useEffect(() => {
    dispatch(resetAddressLookup());
  }, [dispatch]);

  return (
    <WizardPage
      title="Pre-order your Coast cards"
      subtext={
        <>
          Please verify the company name to be printed on your Coast cards,
          <br />
          and the address for your cards to be shipped to if your application is approved.
        </>
      }
      error={error}
      footer={<YouCanComeBackNote />}
    >
      <PreviewCardForm isMobile={isMobile} />
    </WizardPage>
  );
};

export { PreviewCardPage };
